<template>
  <div style="height: 100%">
    <router-view style="height: calc(100% - 70px)"/>
    <van-tabbar v-model="active" @change="tabSwitch3" route class="footer_s">
      <van-tabbar-item v-for="(item,key) in visibleTabList" :key="key" :to="item.href">
        <span>{{item.tabTitle}}</span>
        <template #icon="props">
          <img class="footer_img" :src="props.active ? item.activeIcon : item.icon" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'

  export default {
    name: 'NavBottom',
    data() {
      return {
        active: 0,
        menuHrefSet: new Set(),
        allTabList: [
          {
            'tabTitle': this.$t('append_field.terminal'),
            'curr': false,
            'icon': '/static/images/terminal/terminal.png',
            'activeIcon': '/static/images/terminal/activate-terminal.png',
            'href': '/terminal',
          },
          {
            'tabTitle': this.$t('append_field.program'),
            'curr': false,
            'icon': '/static/images/terminal/program.png',
            'activeIcon': '/static/images/terminal/activate-program.png',
            'href': '/program',
          },
          {
            'tabTitle': this.$t('append_field.my'),
            'curr': false,
            'icon': '/static/images/terminal/my.png',
            'activeIcon': '/static/images/terminal/activate-my.png',
            'href': '/my',
          },
        ]
      }
    },
    computed: {
      ...mapState({
        topTitle: state => state.topTitle,
        topBackIconShow: state => state.topBackIconShow,
        parentPage: state => state.parentPage
      }),
      visibleTabList() {
        const myTab = this.allTabList.find(t => t.href === '/my')
        const list = []
        if (this.menuHrefSet && this.menuHrefSet.has('/terminal')) {
          const t = this.allTabList.find(x => x.href === '/terminal')
          t && list.push(t)
        }
        if (this.menuHrefSet && this.menuHrefSet.has('/program')) {
          const t = this.allTabList.find(x => x.href === '/program')
          t && list.push(t)
        }
        myTab && list.push(myTab)
        return list
      }
    },
    mounted() {
      this.refreshMenuHrefSet()
      this.syncActiveFromRoute()
      window.addEventListener('userMenuListUpdated', this.refreshMenuHrefSet)
      window.addEventListener('userMenuListUpdated', this.syncActiveFromRoute)
      window.addEventListener('storage', this.onStorage)
    },
    watch: {
      '$route.path'() {
        this.syncActiveFromRoute()
      },
      visibleTabList() {
        this.syncActiveFromRoute()
      }
    },
    methods: {
      ...mapActions(['changeTopTitle', 'changeTopIconStatus', 'setParentPage']),
      onStorage(e) {
        if (e && e.key === 'userMenuList') {
          this.refreshMenuHrefSet()
          this.syncActiveFromRoute()
        }
      },
      // 解释：
      // 这里使用的是深度优先遍历（DFS）的方式遍历菜单树，逐个菜单项进行处理。
      // 函数 getMenuHrefs 接受一个菜单树（menuTree）作为参数，并返回一个包含所有菜单项 href 的 Set 集合。
      // 其中，参数 menuTree 是一个由菜单项对象组成的数组，每个菜单项对象包括属性 url，表示菜单项对应的 H5 页面的 URL。
      // 函数 walk 是深度优先遍历函数，它接受一个节点数组 nodes 作为参数，并逐个遍历该数组中的每个节点。
      // 对于每个节点 n，如果它存在且具有属性 url 且 url 不为空字符串，则将其添加到 hrefs 集合中。
      // 如果节点 n 存在且具有属性 children 且 children 是一个非空数组，则递归调用 walk 函数，以遍历子节点。
      // 最后，函数 getMenuHrefs 返回包含所有菜单项 href 的 Set 集合 hrefs。
      getMenuHrefs(menuTree) {
        const hrefs = new Set()
        const walk = (nodes) => {
          if (!Array.isArray(nodes)) return
          nodes.forEach(n => {
            if (n && typeof n.url === 'string' && n.url) {
              hrefs.add(n.url)
            }
            if (n && Array.isArray(n.children) && n.children.length) {
              walk(n.children)
            }
          })
        }
        walk(menuTree)
        return hrefs
      },
      refreshMenuHrefSet() {
        try {
          const raw = localStorage.getItem('userMenuList')
          const menuTree = raw ? JSON.parse(raw) : []
          this.menuHrefSet = this.getMenuHrefs(menuTree)
        } catch (e) {
          this.menuHrefSet = new Set()
        }
      },
      syncActiveFromRoute() {
        const path = this.$route.path
        const idx = this.visibleTabList.findIndex(t => t.href === path)
        this.active = idx >= 0 ? idx : 0
      },
      tabSwitch3: function (value) {
        // this.topTitle = value.tabTitle
        if (this.visibleTabList && this.visibleTabList[value]) {
          this.changeTopTitle(this.visibleTabList[value].tabTitle)
        }
        this.changeTopIconStatus(false)
      },
      goBack() {
        this.$router.push({path: this.parentPage})
        if (this.parentPage == 'taskdetail') {
          this.changeTopTitle(this.$t('append_field.task_details'))
          this.setParentPage('programs')
        } else if (this.parentPage == 'programs') {
          this.changeTopTitle(this.$t('append_field.program'))
          this.changeTopIconStatus(false)
        } else if (this.parentPage == 'my') {
          this.changeTopTitle(this.$t('append_field.my'))
          this.changeTopIconStatus(false)
        } else if (this.parentPage == 'programs') {
          this.changeTopTitle(this.$t('append_field.program'))
          this.changeTopIconStatus(false)
        } else if (this.parentPage == 'information') {
          this.changeTopTitle(this.$t('append_field.terminal'))
          this.changeTopIconStatus(false)
        }
      }
    },
    beforeDestroy() {
      window.removeEventListener('userMenuListUpdated', this.refreshMenuHrefSet)
      window.removeEventListener('userMenuListUpdated', this.syncActiveFromRoute)
      window.removeEventListener('storage', this.onStorage)
    }
  }
</script>

<style lang="scss">
.footer_s{
  background: #F2F2F2;
  border-top: 1px solid #ccc;
  height: 70px;
  .van-tabbar-item{
    font-size: 16px;
  }
  .footer_img{
    margin: 0 auto;
    width: 30px;
    height: 30px;
    display: block;
    background-size: 100% 100%;
    background-position: 50%;
  }
  .van-tabbar-item--active{
    background-color: #F2F2F2;
  }
}
  .topTitle {
    height: 40px;
    background: #006EFF;
    line-height: 40px;
    color: #fff;
    position: relative;
    text-align: center;

    .topTitle-icon {
      position: absolute;
      left: 10px;
      top: 10px;
      font-size: 25px;
    }
  }

  .van-dialog-ok {
    background: #fff;
    border-top: 1px solid #F6F6F6;
    color: #006EFF;
  }

  .van-dialog-title {
    font-weight: 600;
    color: #333 !important;
    text-align: left !important;

  }

  .van-dialog-footer {
    justify-content: flex-end;
    border: none;
    height: 55px;
  }

  .van-dialog-btn {
    height: 35px;
    line-height: 35px;
    padding: 0 10px;
    width: 60px;
    flex: none;
    margin-left: 10px;
    border-radius: 5px;
  }

  .van-dialog-cancel {
    border: 1px solid #e41f19;
    color: #e41f19;
  }

  .van-dialog-cancel:active {
    background: #fff;
    border: 1px solid #e41f19;
  }

  .van-dialog-ok {
    border: 1px solid #006EFF;
    color: #fff;
    background: #006EFF;
    margin-right: 20px;
  }

  .van-dialog-ok:active {
    background: #006EFF;
  }

  .van-dialog__header {
    font-size: 18px !important;
    font-weight: bold;
  }

  .van-dialog__content {
    //padding-top: 15px!important;
    font-size: 18px !important;
  }



  .van-picker {
    .van-picker__toolbar {
      border-bottom: 1px solid #ddd;
      color: #333;

      .van-picker__cancel {
        color: #ee0a24;
      }
    }
  }
</style>
